import { Component, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";

import { AppSettings } from "../../../settings/app.settings";
import { AuthenticationService } from "../../../services/authentication.service";
import { LoadingAnimationService } from "../../../services/loading-animation.service";
import { UserStorageService } from "../../../services/user-storage.service";
import { JqueryExtensionsService } from "../../../services/jquery.service";
import { UserTypeEnum, UserTypeList } from "../../../enums/user-type.enum";
import { LoginToken, ITokenResponse } from "../../../utilities/token";
import { Location } from "../../../utilities/location";

import { IUserCookieModel } from "../../../models/user-cookie.model";

export interface IUserLoginType {
	name: string;
	userType: UserTypeEnum;
}

@Component({
	templateUrl: "login.component.html"
})
export class LoginComponent implements OnInit {
	private defaultLoginType = UserTypeList.filter(x => x.userType === UserTypeEnum.Admin)[0];

	userLoginTypes = UserTypeList;
	user: IUserCookieModel = {
		userName: "",
		password: "",
		userType: this.defaultLoginType.userType || UserTypeEnum.Admin
	};
	userLoginTypeName = this.defaultLoginType.name;
	loginLocally: boolean;
	keepMeLoggedIn: boolean = false;
	error = "";
	loggingIn: boolean = false;

	constructor(
		private appSettings: AppSettings,
		private authenticationService: AuthenticationService,
    private http: HttpClient,
		private router: Router,
		private userStorageService: UserStorageService,
		private loadingAnimationService: LoadingAnimationService,
		private $: JqueryExtensionsService
	) { }

	ngOnInit() {
		let queryParams = this.getQueryParameters(); 
		this.loginLocally = !(!!window.opener) || (queryParams.redirect_uri || "").length <= 0;
		if (this.loginLocally) {
			this.userStorageService.getUser(0);
			this.authenticationService.relogin();
		}
		this.$.focus("#input_email");
	}

	private getQueryParameters() {
		const qp: string = Location.search;
		return (
			qp
			? JSON.parse(
				"{\"" + qp.replace(/&/g, "\",\"").replace(/\=/g, "\":\"") + "\"}",
				function (k: string, v: any): string {
					k = k;
					return typeof v === "string" ? Location.decode(v) : v;
				}
			)
			: {}
		);
	}

	private prepareUrl(url: string, queryParams: any) {
		if (url.indexOf("&hash=") >= 0) { url = url.substring(0, url.indexOf("&hash=")); }
		if (queryParams["debughash"] === "1") { url = url.replace("&debughash=1", ""); }
		return url;
	}

	selectType(userLoginType: IUserLoginType) {
		this.user.userType = userLoginType.userType;
		this.userLoginTypeName = userLoginType.name;
	}

    login() {
		if (!this.user) { return; }
		if (!this.user.userName) {
			this.error = "Username not specified";
			return;
		}
		if (!this.user.password) {
			this.error = "Password not specified";
			return;
		}
		this.loggingIn = true;

		let queryParams = this.getQueryParameters();

		new LoginToken(this.appSettings, this.authenticationService, this.http, this.loadingAnimationService)
			.generate({
				user: {
					userName: this.user.userName,
					password: encodeURIComponent(this.user.password),
					userType: this.user.userType,
					encKey: "",
					employeeId: queryParams.empId,
					hash: queryParams.hash
				},
				url: this.prepareUrl(Location.search, queryParams),
				keepMeLoggedIn: this.keepMeLoggedIn,
				loginLocally: this.loginLocally
			})
			.subscribe((token: ITokenResponse) => {
				if (token.error && token.error_description) {
					this.error = token.error_description;
					this.loggingIn = false;
					return;
				}

				if (!token.access_token || !token.expires_in || !token.enc_key) {
					this.error = "Invalid login data returned";
					this.loggingIn = false;
					return;
				}

				if (!this.loginLocally && !(/^http(s){0,1}\:\/\/.+\..{2,3}/i.test(queryParams.redirect_uri))) {
					this.error = "Invalid redirect location";
					this.loggingIn = false;
					return;
				}

				if (!this.loginLocally) {
					// using S1 for oatuh
					Location.href =
						String(queryParams.redirect_uri) + (String(queryParams.redirect_uri).indexOf("?") >= 0 ? "&" : "?") +
						`access_token=${token.access_token}&` +
						`expires_in=${token.expires_in}&` +
						`enc_key=${token.enc_key}`;
					return;
				} else {
					// logging in locally
					const userData = this.authenticationService.userData;
					if (userData) { this.userStorageService.getUser(<any><number>userData.userId); }

					let redirect = queryParams.s2 ? Location.decode(String(queryParams.s2)).toLowerCase() : "";

					if (redirect) {
						const urls = redirect.split(Location.host.toLowerCase());
						redirect = urls[urls.length - 1];
					}

					redirect = (redirect || "").replace(/^\/\#/, "");

					this.router.navigate([redirect]);
				}
			});
	}
}
